var bookshelf = require("../index-extended");
require("./Media");
require("./BuildingOwner");
require("./Contact");
require("./Meeting");
require("./ResolutionVote");
require("./BuildingOwnerBuildingLot");

module.exports = bookshelf.model("Mandate", {
  entityName: "Mandate",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "mandate",
  // EX: many-to-one
  building_owner() {
    return this.belongsTo("BuildingOwner", "building_owner_id");
  },

  building_owner_building_lots() {
    return this.hasMany("BuildingOwnerBuildingLot", "building_owner_id", "building_owner_id");
  },

  // HACK: .. ..
  representant_owner() {
    return this.belongsTo("BuildingOwner", "representant_owner_id");
  },
  resolution_votes() {
    return this.hasMany("ResolutionVote", "mandate_id");
  },
  representant_contact() {
    return this.belongsTo("Contact", "representant_contact_id");
  },
  meeting() {
    return this.belongsTo("Meeting");
  },
  invitation_pdf() {
    return this.belongsTo("Media", "invitation_id");
  },
  pouvoir_pdf() {
    return this.belongsTo("Media", "pouvoir_id");
  },
  voting_form_pdf() {
    return this.belongsTo("Media", "voting_form_id");
  },
  merged_pdf() {
    return this.belongsTo("Media", "merged_media_id");
  },

  parse(res) {
    if (res.docs_status) res.docs_status = JSON.parse(res.docs_status);
    return res;
  },

  format(attrs) {
    if (attrs.docs_status) attrs.docs_status = JSON.stringify(attrs.docs_status);

    delete attrs["$id"];
    delete attrs["building_owner"];
    delete attrs["representant_owner"];
    delete attrs["representant_contact"];
    delete attrs["resolution_votes"];
    delete attrs["building_owner_building_lots"];
    delete attrs["pouvoir_pdf"];
    delete attrs["invitation_pdf"];
    delete attrs["voting_form_pdf"];
    delete attrs["merged_pdf"];
    delete attrs["pouvoir"];
    delete attrs["invitation"];
    delete attrs["voting_form"];
    delete attrs["merged_media"];

    return attrs;
  },
});
